<template>
  <li class="nav-item dropdown">
    <a
      class="nav-link dropdown-toggle mt-2 mt-lg-0 mb-lg-0 py-1 py-lg-3"
      href="#"
      :id="id"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      {{ menu.label }}
    </a>
    <ul class="dropdown-menu" :aria-labelledby="id">
      <li v-for="item in menu.subitens" :key="item.label">
        <!-- SUBMENU -->
        <template v-if="item.subitens">
          <a class="nav-link">
            {{ item.label }}
            <font-awesome-icon
              icon="caret-right"
              aria-label="Abre submenu"
              title="Abre submenu"
              style="padding-right: -1em; float: right"
            />
          </a>
          <piweb-submenu-item :menu="item.subitens"></piweb-submenu-item>
        </template>

        <!-- LEAF -->
        <component
          :is="linkType"
          class="nav-link"
          aria-current="page"
          :href="item.link ? item.link : '/#'"
          :to="item.link ? item.link : '/#'"
          v-else-if="item.label"
          >{{ item.label }}</component
        >

        <!-- DIVIDER -->
        <hr class="dropdown-divider" v-else />
      </li>
    </ul>
  </li>
</template>

<script>
import PiwebSubmenuItem from "./piweb-submenu-item.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
/* add icons to the library */
library.add(faCaretRight);

export default {
  name: "PiwebMenuItem",
  components: { PiwebSubmenuItem, FontAwesomeIcon },
  props: {
    menu: {
      type: Object,
      default: () => {
        return { label: "Teste", subitens: {} };
      },
    },
  },
  computed: {
    linkType() {
      return this.$router ? "router-link" : "a";
    },
    id() {
      return "navbarDropdown-" + this.menu.label.replace(" ", "_");
    },
  },
};
</script>

<style scoped>
.navbar-light .navbar-nav .nav-link:focus,
.navbar-light .navbar-nav .nav-link:hover {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-nav .nav-link:focus,
.navbar-nav .nav-link:hover {
  background-color: #e7e7e7;
}
</style>